module.exports = __webpack_public_path__ + "0b6be819274cb3611bf52e620b4453.png";